import React from 'react';
import MedicalNotes from '../../containers/MedicalNotes/MedicalNotes';

export class MedicalNotesPage extends React.Component {
  render() {
    return <MedicalNotes />;
  }
}